__turbopack_context__.v({
  "bar": "DiscoveryHeader-module__vYEdNG__bar",
  "chevronOpen": "DiscoveryHeader-module__vYEdNG__chevronOpen",
  "desktopNav": "DiscoveryHeader-module__vYEdNG__desktopNav",
  "dropdown": "DiscoveryHeader-module__vYEdNG__dropdown",
  "dropdownDescription": "DiscoveryHeader-module__vYEdNG__dropdownDescription",
  "dropdownLabel": "DiscoveryHeader-module__vYEdNG__dropdownLabel",
  "dropdownLink": "DiscoveryHeader-module__vYEdNG__dropdownLink",
  "dropdownList": "DiscoveryHeader-module__vYEdNG__dropdownList",
  "dropdownText": "DiscoveryHeader-module__vYEdNG__dropdownText",
  "header": "DiscoveryHeader-module__vYEdNG__header",
  "iconImage": "DiscoveryHeader-module__vYEdNG__iconImage",
  "iconTile": "DiscoveryHeader-module__vYEdNG__iconTile",
  "logo": "DiscoveryHeader-module__vYEdNG__logo",
  "logoLink": "DiscoveryHeader-module__vYEdNG__logoLink",
  "mobileDirectLink": "DiscoveryHeader-module__vYEdNG__mobileDirectLink",
  "mobileItem": "DiscoveryHeader-module__vYEdNG__mobileItem",
  "mobileItemButton": "DiscoveryHeader-module__vYEdNG__mobileItemButton",
  "mobileList": "DiscoveryHeader-module__vYEdNG__mobileList",
  "mobileNav": "DiscoveryHeader-module__vYEdNG__mobileNav",
  "mobilePanel": "DiscoveryHeader-module__vYEdNG__mobilePanel",
  "mobileSubLink": "DiscoveryHeader-module__vYEdNG__mobileSubLink",
  "mobileSubList": "DiscoveryHeader-module__vYEdNG__mobileSubList",
  "mobileToggle": "DiscoveryHeader-module__vYEdNG__mobileToggle",
  "panelGroupLabel": "DiscoveryHeader-module__vYEdNG__panelGroupLabel",
  "tab": "DiscoveryHeader-module__vYEdNG__tab",
  "tabActive": "DiscoveryHeader-module__vYEdNG__tabActive",
  "tabItem": "DiscoveryHeader-module__vYEdNG__tabItem",
  "tabList": "DiscoveryHeader-module__vYEdNG__tabList",
  "topLink": "DiscoveryHeader-module__vYEdNG__topLink",
  "topLinkBar": "DiscoveryHeader-module__vYEdNG__topLinkBar",
  "topLinkCurrent": "DiscoveryHeader-module__vYEdNG__topLinkCurrent",
  "topLinkIcon": "DiscoveryHeader-module__vYEdNG__topLinkIcon",
  "topLinkLabel": "DiscoveryHeader-module__vYEdNG__topLinkLabel",
  "topLinkList": "DiscoveryHeader-module__vYEdNG__topLinkList",
  "topLinkWithIcon": "DiscoveryHeader-module__vYEdNG__topLinkWithIcon",
});
